import React from "react";
import OwlCarousel from "react-owl-carousel";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import { Link } from "react-router-dom";
import Api from '../../services/api';
import { toast } from "react-toastify";
import withRouter from "../../services/withRouter";
import parse from 'html-react-parser';
import Select from 'react-select';


class Eligibility extends React.Component {


    divyang_category = [
        {'label' : 'Yes', 'value' : '0'},
        {'label' : 'No', 'value' : '1'}
    ]

    beneficiary = [
        {'label' : 'APL', 'value' : 0},
        {'label' : 'BPL', 'value' : 1},
        {'label' : 'AAY', 'value' : 2},
        {'label' : 'PHH', 'value' : 3},
        {'label' : 'Applied / In Progress', 'value' : 4},
        {'label' : 'Not Applicable', 'value' : 5}
    ]

    caste = [
        {'label' : 'General', 'value' : 0},
        {'label' : 'OBC', 'value' : 1},
        {'label' : 'SC', 'value' : 2},
        {'label' : 'ST', 'value' : 3},
        {'label' : 'Particularly Vulnerable Tribal Group (PVTG)', 'value' : 4}
    ]

    genders = [
        {'label' : 'Male', 'value' : 0},
        {'label' : 'Female', 'value' : 1},
        {'label' : 'Transgender', 'value' : 2}
    ]
  

    marital_status = [
        {'label' : 'Married', 'value' : 0},
        {'label' : 'Unmarried', 'value' : 1},
        {'label' : 'Widowed / Widhower', 'value' : 2},
        {'label' : 'Divorced', 'value' : 3},
        {'label' : 'Seperated', 'value' : 4}
    ]

    religions = [
        {'label' : 'Hindu', 'value' : 0},
        {'label' : 'Muslim', 'value' : 1},
        {'label' : 'Christian', 'value' : 2},
        {'label' : 'Sikh', 'value' : 3},
        {'label' : 'Parsion', 'value' : 4},
        {'label' : 'Buddhism', 'value' : 5}
    ]

    employment_status = [
        {'label' : 'Employed', 'value' : 0},
        {'label' : 'Self Employed / Entrepreneur', 'value' : 1},
        {'label' : 'Unemployed', 'value' : 2}
    ]

    area = [
        {'label' : 'Urban', 'value' : 0},
        {'label' : 'Rural', 'value' : 1}
    ]



    componentDidMount = async () => {
        window.scrollTo(0, 0);
        await this.getOccupations();
        await this.getStates();
        
    };


    getStates = async()=>{
        var response = await Api.GetRequest({}, 'states');
        if(response.status == 200){
            await this.setState({'states' : response.states});
        }
    }

    getOccupations = async()=>{
        var response = await Api.GetRequest({}, 'occupations');
        if(response.status == 200){
            this.setState({'occupations' : response.occupations});
        }
    }
  

    constructor(props) {
        super(props);
        this.state = {
            'states' : [],
            'occupations' : [],
            'age' : "",
            'state' : {'label' : '', 'value' : ''},
            'dbt' : {'label' : '', 'value' : ''},
            'family_income' : "",
            'beneficiary' : {'label' : '', 'value' : ''},
            'divyang_category' : {'label' : '', 'value' : ''},
            'marital_status' : {'label' : '', 'value' : ''},
            'caste' : {'label' : '', 'value' : ''},
            'gender' : {'label' : '', 'value' : ''},
            'religion' : {'label' : '', 'value' : ''},
            'employment' : {'label' : '', 'value' : ''},
            'area' : {'label' : '', 'value' : ''},
            'occupation' : {'label' : '', 'value' : ''},

            'age_error' : "",
            'state_error' : "",
            'dbt_error' : "",
            'family_income_error' : "",
            'beneficiary_error' : "",
            'divyang_category_error' : "",
            'marital_status_error' : "",
            'caste_error' : "",
            'gender_error' : "",
            'religion_error' : "",
            'employment_error' : "",
            'area_error' : "",
            'occupation_error' : ""
        };
    }

    
    checkEligibility = async()=>{
        var data = {
            'age' : this.state.age,
            'state' : this.state.state.value,
            'family_income' : this.state.family_income,
            'beneficiary' : this.state.beneficiary.value,
            'divyang_category' : this.state.divyang_category.value,
            'marital_status' : this.state.marital_status.value,
            'caste' : this.state.caste.value,
            'gender' : this.state.gender.value,
            'religion' : this.state.religion.value,
            'employment' : this.state.employment.value,
            'area' : this.state.area.value,
            'occupation' : this.state.occupation.value
        }

        var status = true;
        if(data.age.length == 0){
            this.setState({'age_error' : "Please enter age."});
            status = false;
        }
        else{
            this.setState({'age_error' : ""})
        }

        if(data.state.length == 0){
            this.setState({'state_error' : "Please select state."});
            status = false;
        }
        else{
            this.setState({'state_error' : ""})
        }

        if(data.family_income.length == 0){
            this.setState({'family_income_error' : "Please enter family income."});
            status = false;
        }
        else{
            this.setState({'family_income_error' : ""})
        }
        if(data.beneficiary.length == 0){
            this.setState({'beneficiary_error' : "Please select ration card holder."});
            status = false;
        }
        else{
            this.setState({'beneficiary_error' : ""})
        }
        
        if(data.divyang_category.length == 0){
            this.setState({'divyang_category_error' : "Please select divyang category."});
            status = false;
        }
        else{
            this.setState({'divyang_category_error' : ""})
        }

        if(data.marital_status.length == 0){
            this.setState({'marital_status_error' : "Please select marital status."});
            status = false;
        }
        else{
            this.setState({'marital_status_error' : ""})
        }


        if(data.caste.length == 0){
            this.setState({'caste_error' : "Please select caste."});
            status = false;
        }
        else{
            this.setState({'caste_error' : ""})
        }

        if(data.gender.length == 0){
            this.setState({'gender_error' : "Please select gender."});
            status = false;
        }
        else{
            this.setState({'gender_error' : ""})
        }

        if(data.religion.length == 0){
            this.setState({'religion_error' : "Please select religion."});
            status = false;
        }
        else{
            this.setState({'religion_error' : ""})
        }

        if(data.employment.length == 0){
            this.setState({'employment_error' : "Please select employment."});
            status = false;
        }
        else{
            this.setState({'employment_error' : ""})
        }

        if(data.area.length == 0){
            this.setState({'area_error' : "Please select area."});
            status = false;
        }
        else{
            this.setState({'area_error' : ""})
        }

        if(data.occupation.length == 0){
            this.setState({'occupation_error' : "Please select occupation."});
            status = false;
        }
        else{
            this.setState({'occupation_error' : ""})
        }

        if(status == true){
            this.props.navigate("/eligibility/schemes", { state: data });
        }
        else{
            window.scroll(0, 0)
        }
       

            
    }


    render(){

        return(
            <>
                {/* <div class="m-0 shadow"  style={{'width' : '100vw!important', 'maxWidth' : '100vw!important'}}>
                    <div class="row mx-0">
                        <div class="col-lg-12">
                            <div class="commn_banner_page" style={{'position' : 'relative'}}>
                                <img src="/assets/img/header_banner.png"/>
                                <h2 className="text-center mb-0 page-label" style={{'position' : 'absolute', 'top' : '40%', 'left' : '10%', 'color' : '#000000', "textTransform" : "uppercase"}}>Check Eligibility</h2>
                            </div>
                        </div>
                    </div>
                </div> */}

                <div class="m-0 shadow"  style={{'width' : '100vw!important', 'maxWidth' : '100vw!important'}}>
                    <div class="row mx-0">
                        <div class="col-lg-12 p-0">
                            <div class="commn_banner_page" style={{'position' : 'relative'}} >
                                <img src="/assets/img/header_banner.png" class="page-banner-image" style={{'width' : '100vw'}}/>
                                <h2 className="text-center mb-0 page-label" style={{'position' : 'absolute', 'top' : '40%', width:'50%', lineHeight:'normal', 'left' : '10%', 'color' : '#000000', "textTransform" : "uppercase"}}>Check Eligibility</h2>
                            </div>
                        </div>
                    </div>
                </div>

                <section id="trending_causes_main" className="eligibility-section" style={{'backgroundImage' : "url(" + "assets/img/eligibility.jpg" + ")", 'backgroundPosition': 'center', 'backgroundSize': 'contain', 'backgroundRepeat': 'no-repeat'}}>
                    <div className="mx-2">
                        <div className="row justify-content-center d-flex align-items-center" id="counter">
                            <div className="col-lg-1" style={{'position' : 'relative'}}></div>
                            <div className="col-lg-6" style={{'position' : 'relative'}}>
                                <div className="p-2 card" style={{'background-color': 'var(--main-color)', color:'#FFFFFF', 'position': 'absolute', 'top' : '-40px', 'width' : '96%', 'left': '2%', 'right' : '0'}}>
                                    <h3>CHECK YOUR ELIGIBILITY</h3>
                                    <h6>Fill out this form to search schemes as per your criteria!</h6>
                                </div>
                                
                                <div className="sidebar_boxed row mt-3">

                                    <div className="col-md-6 form-group text-start my-2">
                                        <label style={{'textAlign' : "start", "width":"100%", 'fontWeight' : 'bold'}} className="my-2">Gender *</label>
                                        <Select isRtl={false} options={this.genders} value={this.state.gender} onChange={async(e)=>{await this.setState({"gender" : e})}} />
                                        <small style={{'color' : 'red'}}>{this.state.gender_error}</small>
                                    </div>

                                    <div className="col-md-6 form-group text-start my-2">
                                        <label style={{'textAlign' : "start", "width":"100%", 'fontWeight' : 'bold'}} className="my-2">Age *</label>
                                        <input type="number" style={{'height' : 'auto', background : '#FFFFFF'}} min={0} value={this.state.age} className="form-control border" onChange={async(e)=>{await this.setState({age : e.target.value})}}  />
                                        <small style={{'color' : 'red'}}>{this.state.age_error}</small>
                                    </div>

                                    <div className="col-md-6 form-group text-start my-2">
                                        <label style={{'textAlign' : "start", "width":"100%", 'fontWeight' : 'bold'}} className="my-2">Martial Status *</label>
                                        <Select isRtl={false} options={this.marital_status} value={this.state.marital_status} onChange={async(e)=>{await this.setState({"marital_status" : e})}} />
                                        <small style={{'color' : 'red'}}>{this.state.marital_status_error}</small>
                                    </div>

                                    <div className="col-md-6 form-group text-start my-2">
                                        <label style={{'textAlign' : "start", "width":"100%", 'fontWeight' : 'bold'}} className="my-2">Religion *</label>
                                        <Select isRtl={false} options={this.religions} value={this.state.religion} onChange={async(e)=>{await this.setState({"religion" : e})}} />
                                        <small style={{'color' : 'red'}}>{this.state.religion_error}</small>
                                    </div>

                                    <div className="col-md-6 form-group text-start my-2">
                                        <label style={{'textAlign' : "start", "width":"100%", 'fontWeight' : 'bold'}} className="my-2">Caste *</label>
                                        <Select isRtl={false} options={this.caste} value={this.state.caste} onChange={async(e)=>{await this.setState({"caste" : e})}} />
                                        <small style={{'color' : 'red'}}>{this.state.caste_error}</small>
                                    </div>

                                    <div className="col-md-6 form-group text-start my-2">
                                        <label style={{'textAlign' : "start", "width":"100%", 'fontWeight' : 'bold'}} className="my-2">Divyang Category *</label>
                                        <Select isRtl={false} options={this.divyang_category} value={this.state.divyang_category} onChange={async(e)=>{await this.setState({"divyang_category" : e})}} />
                                        <small style={{'color' : 'red'}}>{this.state.divyang_category_error}</small>
                                    </div>

                                    <div className="col-md-6 form-group text-start my-2">
                                        <label style={{'textAlign' : "start", "width":"100%", 'fontWeight' : 'bold'}} className="my-2">Ration Card Holder *</label>
                                        <Select isRtl={false} options={this.beneficiary} value={this.state.beneficiary} onChange={async(e)=>{await this.setState({"beneficiary" : e})}} />
                                        <small style={{'color' : 'red'}}>{this.state.beneficiary_error}</small>
                                    </div>

                                    <div className="col-md-6 form-group text-start my-2">
                                        <label style={{'textAlign' : "start", "width":"100%", 'fontWeight' : 'bold'}} className="my-2">Employment Status *</label>
                                        <Select isRtl={false} options={this.employment_status} value={this.state.employment} onChange={async(e)=>{await this.setState({"employment" : e})}} />
                                        <small style={{'color' : 'red'}}>{this.state.employment_error}</small>
                                    </div>
                                   
                                    <div className="col-md-6 form-group text-start my-2">
                                        <label style={{'textAlign' : "start", "width":"100%", 'fontWeight' : 'bold'}} className="my-2">Occupation *</label>
                                        <Select isRtl={false} options={this.state.occupations} value={this.state.occupation} onChange={async(e)=>{await this.setState({"occupation" : e})}} />
                                        <small style={{'color' : 'red'}}>{this.state.occupation_error}</small>
                                    </div>

                                    <div className="col-md-6 form-group text-start my-2">
                                        <label style={{'textAlign' : "start", "width":"100%", 'fontWeight' : 'bold'}} className="my-2">Monthly Income *</label>
                                        <input type="number" style={{'height' : 'auto', background : '#FFFFFF'}} min={0} value={this.state.family_income} className="form-control border" onChange={async(e)=>{await this.setState({family_income : e.target.value})}} />
                                        <small style={{'color' : 'red'}}>{this.state.family_income_error}</small>
                                    </div>

                                    <div className="col-md-6 form-group text-start my-2">
                                        <label style={{'textAlign' : "start", "width":"100%", 'fontWeight' : 'bold'}} className="my-2">State / Union Territories *</label>
                                        <Select isRtl={false} options={this.state.states} value={this.state.state} onChange={async(e)=>{await this.setState({"state" : e})}} />
                                        <small style={{'color' : 'red'}}>{this.state.state_error}</small>
                                    </div>

                                    <div className="col-md-6 form-group text-start my-2">
                                        <label style={{'textAlign' : "start", "width":"100%", 'fontWeight' : 'bold'}} className="my-2">Area of Residence *</label>
                                        <Select isRtl={false} options={this.area} value={this.state.area} onChange={async(e)=>{await this.setState({"area" : e})}} />
                                        <small style={{'color' : 'red'}}>{this.state.area_error}</small>
                                    </div>

                                    <div className="col-12 mt-3">
                                        <button type="button" onClick={()=>{this.checkEligibility()}}  className="btn btn_theme btn_md">Check</button>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-3" style={{'position' : 'relative'}}></div>
                            <div className="col-lg-2" style={{'position' : 'relative'}}></div>
                        </div>
                    </div>
                </section>
            </>
        )
    }
}


export default withRouter(Eligibility)